function Results() {
  const results = [
    {
      before: "Вместо тревоги",
      after: "План",
      description: "Внутренний шум сменится холодным расчетом.",
    },
    {
      before: "Вместо вины",
      after: "Выполнено",
      description: "Галки напротив задач дисциплинируют мозг.",
    },
    {
      before: "Вместо хаоса",
      after: "Деньги",
      description: "Ты поймешь, где теряешь прибыль.",
    },
  ]

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-[#1E2B3C] fade-on-scroll opacity-0">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-white mb-12 sm:mb-16 uppercase">
          РЕЗУЛЬТАТЫ ЧЕРЕЗ 7 ДНЕЙ
        </h2>

        <div className="grid sm:grid-cols-3 gap-8 sm:gap-10">
          {results.map((result, index) => (
            <div
              key={index}
              className="text-center space-y-4"
            >
              <div className="text-lg sm:text-xl text-gray-400 line-through">
                {result.before}
              </div>
              <div className="text-3xl sm:text-4xl font-black text-[#F45B3C]">
                {result.after}
              </div>
              <p className="text-base sm:text-lg text-gray-200 leading-relaxed">
                {result.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Results
